var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stamp-layout"},[_c('span',{staticClass:"stamp",on:{"click":function($event){return _vm.click()}}},[_c(_vm.stampComponent,{tag:"component",attrs:{"width":_vm.width,"height":_vm.height,"icon-color":_vm.stampColor}})],1),_vm._v(" "),_c('br'),_c('span',{style:(_vm.stampCounter)},[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d409258","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stamp.vue
// module id = 506
// module chunks = 1